import routerOptions0 from "/home/runner/work/famitei.co.jp-web2/famitei.co.jp-web2/web/node_modules/nuxt/dist/pages/runtime/router.options";
import routerOptions1 from "/home/runner/work/famitei.co.jp-web2/famitei.co.jp-web2/web/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}